import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import { Route } from 'vue-router'
import RootState from '../../store/state'
import { Getters } from '../../store/manager/helpers'
import { ArticleData } from '../../store/manager/state'
import { MenuEvent } from './ArticleMenuInterface'

import ArticleCardType from './ArticleCardType.vue'

@Component({
  components: {
    'article-card-type': ArticleCardType
  }
})
export default class ArticlesManage extends Vue {
  name: 'articlesManage'
  $store: Store<RootState>
  $route: Route
  menuData: MenuEvent<ArticleData> = {
    name: 'dummy',
    data: {}
  }

  get articles(): ArticleData[] {
    return this.$store.state.manager.articles || []
  }

  get siteId(): number {
    return Getters.getAcountData(this.$store).kajikiId
  }

  get emptyCardSize(): number {
    // 件数が少ない時、空の要素の個数を多く付与させることでレイアウトと崩れを防ぐ
    return Math.max(this.articles.length, 4)
  }

  get isLoadingArticle(): boolean {
    return Getters.isLoadingArticle(this.$store)
  }

  menuSelected(componentName: string) {
    return this.$emit('menu-selected', componentName)
  }
}
